import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import { COLORS, PrimaryButton } from "./wtStyle";

// FR-21: every error/warning in this module goes through this dialog —
// never a native alert()/confirm(). Render once per page, control via a
// {type, title, message} | null state value.
const TONE = {
  error: { color: COLORS.red, label: "Error" },
  warning: { color: COLORS.orange, label: "Warning" },
  success: { color: COLORS.green, label: "Done" },
};

export default function WorkTransferNotice({ notice, onClose }) {
  if (!notice) return null;
  const tone = TONE[notice.type] || TONE.warning;

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ color: tone.color, fontWeight: 700, fontSize: 18 }}>{notice.title || tone.label}</DialogTitle>
      <DialogContent>
        <Typography fontSize={13.5} color={COLORS.textSecondary}>{notice.message}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <PrimaryButton onClick={onClose}>OK</PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}
